import {
  countryDialCodes,
  countryKeys,
  countryTranslationKeys,
  prioritizedCountryKeys,
} from '@mnd-frontend/ui/shared/lists/countries';
import { useTranslation } from 'react-i18next';

type CountryKey = keyof typeof countryTranslationKeys;

const createCountryList = <T>(countryKeys: T extends Readonly<Array<CountryKey>> ? T : never) => {
  const { t } = useTranslation();

  return countryKeys
    .map(key => {
      const translatedValue = t(countryTranslationKeys[key]);
      if (!translatedValue.startsWith('locale')) {
        return { label: translatedValue, value: key };
      }
      return null;
    })
    .filter(Boolean) as { label: string; value: T }[];
};

const separator = { label: '---', value: '' };

export const countryOptions = () => {
  const prioritized = createCountryList<typeof prioritizedCountryKeys>(prioritizedCountryKeys);
  const rest = createCountryList<typeof countryKeys>(countryKeys);

  return [...prioritized, separator, ...rest];
};

export const dialCodeOptions = () =>
  Object.entries(countryDialCodes).map(([country, dial]) => ({ label: `${dial}`, value: country }));
